import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WorkOrderTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: WorkOrderTableRow[];
  loading?: boolean;
};

const WorkOrderTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const navigate = useNavigate();

  const handleRowClick = (row: WorkOrderTableRow) => {
    navigate(`/work-orders/${row.id}`);
  };

  const columns = useMemo(
    () => [
      {
        id: "priority",
        label: t("WORK_ORDER.TABLE.PRIORITY"),
        minWidth: 100,
        align: "right",
        format: (row: WorkOrderTableRow) => (
          <Box className={styles.priorityCell}>
            <OutlinedFlagIcon
              className={clsx(
                styles.priorityIcon,
                styles[`priority${row.priority}`]
              )}
            />
            <span>{t(`WORK_ORDER.PRIORITY_VALUES.${row.priority}`)}</span>
          </Box>
        ),
      },
      {
        id: "progress",
        label: t("WORK_ORDER.TABLE.PROGRESS"),
        minWidth: 90,
        align: "right",
        format: (row: WorkOrderTableRow) => `${row.progress}%`,
      },
      {
        id: "currentStage",
        label: t("WORK_ORDER.TABLE.CURRENT_STAGE"),
        minWidth: 140,
        align: "right",
        format: (row: WorkOrderTableRow) =>
          t(`WORK_ORDER.STAGE_VALUES.${row.currentStage}`),
      },
      {
        id: "vehicle",
        label: t("WORK_ORDER.TABLE.VEHICLE"),
        minWidth: 160,
        align: "right",
        format: (row: WorkOrderTableRow) =>
          t(`WORK_ORDER.VEHICLE_VALUES.${row.vehicle}`),
      },
      {
        id: "customerName",
        label: t("WORK_ORDER.TABLE.CUSTOMER_NAME"),
        minWidth: 140,
        align: "right",
        format: (row: WorkOrderTableRow) =>
          t(`WORK_ORDER.CUSTOMER_VALUES.${row.customerName}`),
      },
      {
        id: "status",
        label: t("WORK_ORDER.TABLE.STATUS"),
        minWidth: 110,
        align: "right",
        format: (row: WorkOrderTableRow) => (
          <span className={styles.statusBadge}>
            {t(`WORK_ORDER.STATUS_VALUES.${row.status}`)}
          </span>
        ),
      },
      {
        id: "workOrderId",
        label: t("WORK_ORDER.TABLE.ID"),
        minWidth: 100,
        align: "right",
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        onRowClick={handleRowClick}
        isPointerCursor
      />
    </div>
  );
};

export default WorkOrderTable;
